import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { unhideBankTransaction } from "../../../redux/actions/dashboard.js";
import UndoableItem from "./UndoableItem.jsx";

export default function ToastHideBankTransactionUndo() {

	const dispatch = useDispatch();
	const lastHiddenBankTransaction = useSelector((state) => state.plaid.lastHiddenBankTransaction);


	function getItemId(item) {
		return item.plaid_transaction_id;
	}

	function undoButtonClicked(item) {
		dispatch(unhideBankTransaction(item));
	}

	function itemHasChangeThatCanBeUndone(item) {
		return item.hidden;
	}

	return (
		<UndoableItem
			item={lastHiddenBankTransaction}
			getItemId={getItemId}
			itemHasChangeThatCanBeUndone={itemHasChangeThatCanBeUndone}
			undoButtonClicked={undoButtonClicked}
			afterClickedUndoContent={(item) => {
				return `Restored ${item.name}`;
			}}
			canUndoContent={(bankTransaction) => {
				return (
					<span>Transaction Hidden <span className='institution_name'>{bankTransaction.name}</span></span>
				);
			}}
		/>
	);
}